<template>
  <div class="container mx-auto">
    <div class="mb-6">
      <div class="flex justify-between mb-4">
        <div class="flex-1 min-w-0">
          <router-link to="/" class="inline-flex text-gray-700 hover:text-gray-900 border px-4 py-1 rounded text-xs border-gray-600 hover:bg-gray-300">Regresar a lista de empleados</router-link>
        </div>
        <div class="flex">
          <span class="px-4 text-xs font-medium text-gray-800 bg-gray-200 border rounded-md border-transparent py-1">{{ this.$route.params.nombreempleado }}</span>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-9">
        <h4 class="font-semibold text-xl text-gray-800 mb-6">Bonos</h4>
      </div>
      <div class="col-span-3 justify-self-end">
        <NavExpediente :registroEmpleado="this.$route.params.nombreempleado" :empleadoId="this.$route.params.id" />
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mb-8">
      <div class="col-span-3">
        <router-link :to="{ name: 'bono-nuevo', params: { id: this.$route.params.id, nombreempleado: this.$route.params.nombreempleado } }" class="bg-blue-500 hover:bg-blue-600 text-white text-xs py-2 px-8 rounded focus:outline-none focus:shadow-outline mr-auto">Agregar Bono</router-link>
      </div>
    </div>
    <ListBonos :bonos="bonos" @onBonosStatus="bonosStatus" class="mb-6"/>
    <Pagination :count="bonosCount" :activePage="activePage" @onChangePage="cambiarPaginacion" />
  </div>
</template>

<script>
import NavExpediente from '@/components/NavExpediente'
import authClient from '@/utils/auth'
import ListBonos from '@/components/ListBonos'
import Pagination from '@/components/Pagination'
export default {
  name: 'EmpleadoBonos',
  components: {
    NavExpediente,
    ListBonos,
    Pagination
  },
  data () {
    return {
      bonos: [],
      bonosCount: 0,
      activePage: 0
    }
  },
  methods: {
    obtenerBonos () {
      this.$http.post('/api/exp-bono/bonos-empleado', { empleado: this.$route.params.id, page: this.activePage }, {
        headers: {
          Authorization: authClient.getAuthToken()
        }
      }).then(({ data }) => (this.bonos = data))
      this.$http.post('/api/exp-bono/bonos-empleado-count', { empleado: this.$route.params.id }, {
        headers: {
          Authorization: authClient.getAuthToken()
        }
      }).then(({ data }) => (this.bonosCount = data))
    },
    cambiarPaginacion (pageSelected) {
      this.activePage = pageSelected
      this.obtenerBonos()
    },
    bonosStatus (bonoId, bonoStatus) {
      this.$http.put(`/api/exp-bono/${bonoId}`, {
        activo: !bonoStatus
      }, {
        headers: {
          Authorization: authClient.getAuthToken()
        }
      })
        .then(() => this.obtenerBonos())
    }
  },
  mounted () {
    this.obtenerBonos()
  }
}
</script>
